(function () {
    'use strict';

    angular
        .module('salesflare.components.regularFlag', [])
        .component('sfRegularFlag', {
            controller: RegularFlagController,
            controllerAs: 'vm',
            templateUrl: 'app-ajs/components/regularFlag/regularFlag.html',
            bindings: {
                text: '<',
                dynamicText: '&?',
                flag: '<'
            }
        });

    function RegularFlagController() {

        const vm = this;
        vm.description = '';

        vm.$onInit = function () {

            vm.description = vm.text;
        };

        vm.getDescription = () => {
            if (angular.isFunction(this.dynamicText)) {
                return this.dynamicText();
            }

            return vm.description;
        };
    }
}());
